import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Pageable} from '../../models/common/pageable.model';
import {QueryUserGroupModel} from '../../models/user/query-user-group.model';
import {
  CreateUserGroupRequest,
  UpdateUserGroupRequest,
  UserGroupDetailModel,
  UserGroupMemberModel
} from '../../models/user/user-group-detail.model';

@Injectable({
  providedIn: 'root'
})
export class UserGroupService {
  private readonly baseUrl = `${environment.backend.url}/api/user-group/v1`;

  constructor(private readonly http: HttpClient) {}

  public getUserGroups(page: number, pageSize: number): Observable<Pageable<QueryUserGroupModel>> {
    const params = new HttpParams()
      .append('page', page)
      .append('pageSize', pageSize);

    return this.http.get<Pageable<QueryUserGroupModel>>(`${this.baseUrl}/search`, {params});
  }

  public getById(groupId: number): Observable<UserGroupDetailModel> {
    return this.http.get<UserGroupDetailModel>(`${this.baseUrl}/by-id/${groupId}`);
  }

  public create(payload: CreateUserGroupRequest): Observable<{ id: number }> {
    return this.http.post<{ id: number }>(`${this.baseUrl}/create`, payload);
  }

  public update(groupId: number, payload: UpdateUserGroupRequest): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/update/${groupId}`, payload);
  }

  public getGroupRoles(groupId: number): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/roles/${groupId}`);
  }

  public getGroupUsers(groupId: number, page: number, pageSize: number): Observable<Pageable<UserGroupMemberModel>> {
    const params = new HttpParams()
      .append('page', page)
      .append('pageSize', pageSize);
    return this.http.get<Pageable<UserGroupMemberModel>>(`${this.baseUrl}/users/${groupId}`, {params});
  }
}
